module.exports = __webpack_public_path__ + "static/img/2.bc9bcd1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/zh/2.png
// module id = Iv8y
// module chunks = 0